import Turbolinks from "turbolinks";
import bootstrap from "bootstrap";
import jQuery from 'jquery'

Turbolinks.start();
window.$ = window.jQuery = jQuery;
window.bootstrap = bootstrap;
